import React, { useState } from 'react';
import { Box, Typography, Link, Dialog, DialogTitle, DialogContent } from '@mui/material';

const Footer = () => {
  const [showDebugInfo, setShowDebugInfo] = useState(false);
  
  // Get the version and format it to be more user-friendly
  const formatVersion = (version) => {
    if (!version) return 'Unknown';
    
    // Check for staging versions with new format (v1.2.3-staging-abc1234)
    const stagingMatch = version.match(/^(v\d+\.\d+\.\d+)-staging-([a-f0-9]{7})/);
    if (stagingMatch) {
      return `${stagingMatch[1]}-staging-${stagingMatch[2]}`; // Show as v1.2.1-staging-abc1234
    }
    
    // Check for development versions (v1.2.3-dev-abc1234)
    const devMatch = version.match(/^(v\d+\.\d+\.\d+)-dev-([a-f0-9]{7})/);
    if (devMatch) {
      return `${devMatch[1]}-dev-${devMatch[2]}`; // Show as v1.2.1-dev-abc1234
    }
    
    // Extract semantic version (v1.2.3) from full version string for production
    const semanticMatch = version.match(/^(v\d+\.\d+\.\d+)$/);
    if (semanticMatch) {
      return semanticMatch[1]; // Return just the v1.2.3 part for production
    }
    
    // For legacy staging versions with the old format, simplify it
    if (version.startsWith('staging-')) {
      // Extract just the commit hash part
      const hash = version.split('-')[2] || '';
      return `v0.0.0-${hash.substring(0, 7)}`; // Show as v0.0.0-abc1234
    }
    
    // For any other format, return as is
    return version;
  };
  
  // Get the user-friendly release version, fallback to formatted technical version
  const releaseVersion = localStorage.getItem('app_release_version');
  const technicalVersion = localStorage.getItem('app_technical_version');
  const rawVersion = localStorage.getItem('app_version') || 'Unknown';
  const version = releaseVersion || formatVersion(rawVersion);
  
  const handleVersionDoubleClick = () => {
    setShowDebugInfo(true);
  };
  
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: 'auto',
        backgroundColor: 'background.default',
      }}
    >
      <Typography variant="body2" color="text.secondary" align="center">
        {'Copyright © '}
        <Link color="inherit" href="https://educationdatacollective.com/">
          Education Data Collective
        </Link>{' '}
        {new Date().getFullYear()}
        {' • '}
        <Typography
          component="span"
          variant="body2"
          color="text.secondary"
          sx={{ 
            opacity: 0.8,
            cursor: 'pointer',
            userSelect: 'none'
          }}
          onDoubleClick={handleVersionDoubleClick}
          title="Double-click for technical details"
        >
          {version}
        </Typography>
      </Typography>
      
      <Dialog 
        open={showDebugInfo} 
        onClose={() => setShowDebugInfo(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Version Information (Support Debug)</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            <strong>Release Version:</strong> {releaseVersion || 'Not available'}
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            <strong>Technical Version:</strong> {technicalVersion || 'Not available'}
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            <strong>Raw Version:</strong> {rawVersion}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Please share the "Release Version" with support when reporting issues.
            The technical version is for debugging purposes only.
          </Typography>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default Footer;